<template>
  <div>
    <MainMenu />
    <div class="azv-lookup">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 offset-lg-3" v-if="!result">
            <div class="form-wrapper">
              <form class="form" @submit.prevent="submit">
                <div class="mb-3">
                  <label for="azv" class="form-label">AZV Number</label>
                  <input
                    required
                    type="text"
                    class="form-control form-control-lg"
                    id="azv"
                    placeholder="eg. 1071234567"
                    v-model="azvNumber"
                    :disabled="loading"
                  />
                  <div class="hint">Fill in your AZV number to lookup your vaccine appointments</div>
                </div>
                <button type="submit" class="btn btn-primary float-right btn-lg mt-4" :disabled="loading">
                  Submit <i class="fas fa-arrow-right"></i>
                </button>
                <div v-if="loading" class="spinner-border float-right text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </form>
              <div class="clearfix"></div>

              <div class="alert mt-4" role="alert" :class="'alert-' + message.type" v-if="message.text">{{ message.text }}</div>
            </div>
          </div>

          <transition name="fade">
            <div class="col-lg-8 offset-lg-2" v-if="result">
              <div>
                <table class="table" style="background: white">
                  <tbody>
                    <tr>
                      <td>First Appointment</td>
                      <td>{{ result.appointment1 }}</td>
                    </tr>
                    <tr>
                      <td>Second Appointment</td>
                      <td>{{ result.appointment2 }}</td>
                    </tr>
                    <tr>
                      <td>Location</td>
                      <td>{{ result.location }}</td>
                    </tr>
                    <tr>
                      <td>Location Address</td>
                      <td>{{ result.locationAddress }}</td>
                    </tr>
                  </tbody>
                </table>
                <button class="btn btn-primary float-right btn-sm mt-4" @click="resetForm()"><i class="fas fa-arrow-left"></i> Reset</button>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainMenu from '@/components/main-menu.vue';
import axios from 'axios';
export default {
  components: {
    MainMenu,
  },
  data() {
    return {
      azvNumber: null,
      loading: false,
      baseUrlApi: null,
      message: {
        text: null,
        type: null,
      },
      result: null,
    };
  },
  methods: {
    async submit() {
      if (!this.azvNumber) return;
      this.loading = true;
      this.resetMessage();
      try {
        let result = await axios.get(`${this.$baseUrlApi}/healthcheck-restful-api/public/azv/${this.azvNumber}`);
        if (result.status == 200) {
          this.result = result.data;
        } else if (result.status == 204) {
          this.message.text = 'No results for this AZV number';
          this.message.type = 'danger';
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    resetMessage() {
      this.message.text = null;
      this.message.type = null;
    },
    resetForm() {
      this.result = null;
      this.azvNumber = null;
    },
  },
};
</script>

<style lang="scss">
.azv-lookup {
  text-align: left;
  height: 100vh;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  margin-top: 60px;
  .alert.no-background {
    background: #edf6ff;
    font-size: 14px;
    margin-bottom: 20px;
  }
  .form {
    label {
      font-size: 18px;
    }
    .spinner-border {
      margin-top: 31px;
      margin-right: 10px;
    }

    ::placeholder {
      color: darken(lightgrey, 10%);
    }

    .hint {
      margin-top: 7px;
      font-size: 13px;
      color: #4276d3;
      margin-left: 2px;
    }
  }
}
</style>